import { createSelector } from '@ngrx/store';

import { AppState } from '../index';
import { CurrencyState } from './currency.model';

export const getCurrencyState = (appState: AppState): CurrencyState => appState.currency;

export const selectCurrency = createSelector(getCurrencyState, (state) => state?.international);
